export default __webpack_public_path__ + "static/media/screen6.b0f2c96c.webp";